"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _defineProperty2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _consignerInfo = _interopRequireDefault(require("./consignerInfo"));
var _consignerReceiveInfo = _interopRequireDefault(require("./consignerReceiveInfo"));
var _consignerInfoOne = _interopRequireDefault(require("./consignerInfoOne"));
var _consignerInfoTwo = _interopRequireDefault(require("./consignerInfoTwo"));
var _bookCargo = _interopRequireDefault(require("./bookCargo"));
var _dropTitle = _interopRequireDefault(require("./dropTitle"));
var _bookInfo = _interopRequireDefault(require("./bookInfo"));
var _boxInfo = _interopRequireDefault(require("./boxInfo"));
var _bookMaterialsMainInfo = _interopRequireDefault(require("./bookMaterialsMainInfo"));
var _bookMaterialsWebFeeItem = _interopRequireDefault(require("./bookMaterialsWebFeeItem"));
var _bookMaterialsWebBkYard = _interopRequireDefault(require("./bookMaterialsWebBkYard"));
var _bookMaterialsWebBkDocument = _interopRequireDefault(require("./bookMaterialsWebBkDocument"));
var _utils = require("@/utils");
var _acceesorySitc = _interopRequireDefault(require("@/componentsBuz/Accessory/acceesorySitc.vue"));
var _copyBook = _interopRequireDefault(require("./copyBook"));
var _SailSchedule = _interopRequireDefault(require("@/components/SailSchedule"));
var _booking = require("@/api/bookSpace/booking");
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//  下货箱信息
var _default2 = exports.default = {
  name: "bookMaterialsDetailCpt",
  components: {
    sailSchedule: _SailSchedule.default,
    acceesorySitc: _acceesorySitc.default,
    copyBook: _copyBook.default,
    bookMaterialsMainInfo: _bookMaterialsMainInfo.default,
    bookMaterialsWebFeeItem: _bookMaterialsWebFeeItem.default,
    bookMaterialsWebBkYard: _bookMaterialsWebBkYard.default,
    bookMaterialsWebBkDocument: _bookMaterialsWebBkDocument.default,
    consignerInfo: _consignerInfo.default,
    consignerReceiveInfo: _consignerReceiveInfo.default,
    consignerInfoOne: _consignerInfoOne.default,
    consignerInfoTwo: _consignerInfoTwo.default,
    dropTitle: _dropTitle.default,
    bookInfo: _bookInfo.default,
    bookCargo: _bookCargo.default,
    boxInfo: _boxInfo.default
  },
  props: {
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    differentKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    consignerCheck: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    consigneeCheck: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    notifierOneCheck: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    notifierTwoCheck: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bkCargoDiff: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bkPreContainerDiff: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bkContainerDiff: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    feeItemDiff: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bkYardDiff: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bkDocumentDiff: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titleFlag: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var _rules;
    return {
      packageTypeList: [],
      cargoListType: [{
        code: '0',
        name: 'Export'
      }, {
        code: '1',
        name: 'Reshipment'
      }],
      transportationTermsList: [{
        value: '1',
        labelZh: 'SIMIS主系统基础数据-运输条款',
        labelEh: 'SIMIS main system basic data - Shipping terms'
      }],
      bookingTypeList: [],
      paidTypeList: [{
        value: '0',
        labelEh: 'PP'
      }, {
        value: '1',
        labelEh: 'CC'
      }],
      cargoList: [],
      containerTypeList: [{
        value: '0',
        labelEh: '20GP'
      }, {
        value: '1',
        labelEh: '40GP'
      }],
      directionList: [{
        value: '0',
        labelEh: 'One Way',
        labelZh: '单程'
      }, {
        value: '1',
        labelEh: 'Two Way',
        labelZh: '双程'
      }],
      rules: (_rules = {
        componentDesc: [{
          required: true,
          trigger: 'blur'
        }],
        containerType: [{
          required: true,
          trigger: 'change'
        }],
        quantity: [{
          required: true,
          trigger: 'blur'
        }],
        cargoTypeCode: [{
          required: true,
          trigger: 'change'
        }],
        tripNumber: [{
          required: true,
          trigger: 'blur'
        }],
        lineType: [{
          required: true,
          trigger: 'change'
        }],
        serviceLineCode: [{
          required: true,
          trigger: 'change'
        }],
        vesselCode: [{
          required: true,
          trigger: 'change'
        }],
        vesselName: [{
          required: true,
          trigger: 'blur'
        }],
        voyageNo: [{
          required: true,
          trigger: 'blur'
        }],
        voyageLeg: [{
          required: true,
          trigger: 'blur'
        }],
        portFrom: [{
          required: true,
          trigger: 'change'
        }],
        portTo: [{
          required: true,
          trigger: 'change'
        }],
        classType: [{
          required: true,
          trigger: 'blur'
        }],
        unSeriseNo: [{
          required: true,
          trigger: 'blur'
        }],
        property: [{
          required: true,
          trigger: 'blur'
        }],
        packageType: [{
          required: true,
          trigger: 'change'
        }],
        emergencySeq: [{
          required: true,
          trigger: 'blur'
        }],
        emergencyTelNo: [{
          required: true,
          trigger: 'blur'
        }],
        // imoQuantity: [ { required: true, trigger: 'blur' }],
        grossWeight: [{
          required: true,
          trigger: 'blur'
        }],
        netWeight: [{
          required: true,
          trigger: 'blur'
        }],
        packagingCode: [{
          required: true,
          trigger: 'blur'
        }],
        casNo1: [{
          required: true,
          trigger: 'blur'
        }],
        casNo2: [{
          required: true,
          trigger: 'blur'
        }],
        casNo3: [{
          required: true,
          trigger: 'blur'
        }],
        contactName: [{
          required: true,
          trigger: 'blur'
        }],
        contactNumber: [{
          required: true,
          trigger: 'blur'
        }],
        contactTypeCode: [{
          required: true,
          trigger: 'change'
        }],
        //  unit: [ { required: true, trigger: 'blur' }],
        temperature: [{
          required: true,
          trigger: 'blur'
        }],
        akLength: [{
          required: true,
          trigger: 'blur'
        }],
        akWidth: [{
          required: true,
          trigger: 'blur'
        }],
        akHigth: [{
          required: true,
          trigger: 'blur'
        }],
        akGrossWeight: [{
          required: true,
          trigger: 'blur'
        }],
        akNetWeight: [{
          required: true,
          trigger: 'blur'
        }]
      }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_rules, "quantity", [{
        required: true,
        trigger: 'blur'
      }]), "commodityName", [{
        required: true,
        trigger: 'blur'
      }]), "overFront", [{
        required: true,
        trigger: 'blur'
      }]), "overAfter", [{
        required: true,
        trigger: 'blur'
      }]), "overPortside", [{
        required: true,
        trigger: 'blur'
      }]), "overStarboard", [{
        required: true,
        trigger: 'blur'
      }]), "intakeNum", [{
        required: true,
        trigger: 'blur'
      }]), "overHeight", [{
        required: true,
        trigger: 'blur'
      }]), "direction", [{
        required: true,
        trigger: 'change'
      }]), "containerSize", [{
        required: true,
        trigger: 'change'
      }]), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_rules, "sealNo1", [{
        required: true,
        trigger: 'blur'
      }]), "weight", [{
        required: true,
        trigger: 'blur'
      }]), "packageCode", [{
        required: true,
        trigger: 'blur'
      }]), "rateBase", [{
        required: true,
        trigger: 'change'
      }]), "cargoDesc", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "shippingMark", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "packageDesc", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "cargoGrossWeight", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "paidType", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'change'
      }]), "deliveryDocumentMethod", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'change'
      }]), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_rules, "transportationTerms", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'change'
      }]), "freeTimeNo", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "containerNo", [{
        required: true,
        trigger: 'blur'
      }]), "containerManager", [{
        required: true,
        trigger: 'change'
      }]), "por", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "pol", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "pod", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "del", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "bkNo", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "cargoShippingMark", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_rules, "cargoQuantity", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "cargoGrossWeight", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "cargoSize", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'blur'
      }]), "cargoPackageType", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'change'
      }]), "cargoPackageDesc", [{
        required: true,
        message: this.$t('home.placehold'),
        trigger: 'change'
      }]), "bookingFwdEmail", [{
        required: false,
        message: this.$t('home.messageSix'),
        trigger: 'blur'
      }, {
        required: false,
        type: 'email',
        message: this.$t('home.messageThree'),
        trigger: ['blur', 'change']
      }]), "catalogContent", [{
        required: false,
        message: this.$t('home.messageSix'),
        trigger: 'blur'
      }, {
        required: false,
        type: 'email',
        message: this.$t('home.messageThree'),
        trigger: ['blur', 'change']
      }]))
    };
  },
  watch: {},
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  mounted: function mounted() {
    var _this = this;
    this.$dictionary.get(['DOC_SOCRETURN', 'BOOKINGTYPE', 'PAID_TYPE'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.bookingTypeList = res.BOOKINGTYPE;
      _this.paidTypeList = res.PAID_TYPE;
      _this.directionList = res.DOC_SOCRETURN;
    });
    this.queryListPackageType();
  },
  beforeDestroy: function beforeDestroy() {
    this.bookInfo = null;
    this.bookingId = null;
  },
  methods: {
    inputClass: function inputClass(fileName) {
      return {
        'different': this.isDifferent(fileName)
      };
    },
    isDifferent: function isDifferent(fileName) {
      return this.differentKeys.includes(fileName);
    },
    parseTime: _utils.parseTime,
    selectionChange: function selectionChange(row) {
      this.sailScheduleDialogVisible = false;
      var data = this.form.webBkRoutingComs[this.currentIndex];
      data.vesselCode = row.vesselCode;
      data.vesselName = row.vesselName;
      data.voyageNo = row.voyageNo;
      data.voyageLeg = row.voyageLeg;
      data.serviceLineCode = row.serviceLineCode;
    },
    // 获取包装类型
    queryListPackageType: function queryListPackageType() {
      var _this2 = this;
      var data = {
        pageSize: 1000,
        currentPage: 1
      };
      (0, _booking.queryListPackageType)(data).then(function (res) {
        _this2.packageTypeList = res.data.records || [];
      });
      (0, _booking.queryListCode)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "SERVICE_MODE"
      })).then(function (res) {
        _this2.transportationTermsList = res.data || [];
      });
      (0, _booking.queryListCodeName)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "CARGO_TYPE"
      })).then(function (res) {
        _this2.cargoList = res.data || [];
      });
      (0, _booking.queryListCode)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "EQUIPMENT"
      })).then(function (res) {
        _this2.containerTypeList = res.data || [];
      });
    }
  }
};